module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bl-67c5ef35e02e55d24b8c4e94cf8a661f.svg";